import { render, staticRenderFns } from "./CompetitionProductInfoForm.vue?vue&type=template&id=9e8d1d5a"
import script from "./CompetitionProductInfoForm.vue?vue&type=script&lang=js"
export * from "./CompetitionProductInfoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e8d1d5a')) {
      api.createRecord('9e8d1d5a', component.options)
    } else {
      api.reload('9e8d1d5a', component.options)
    }
    module.hot.accept("./CompetitionProductInfoForm.vue?vue&type=template&id=9e8d1d5a", function () {
      api.rerender('9e8d1d5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/priceSetting/priceMonitoring/competitionProductConfig/CompetitionProductInfoForm.vue"
export default component.exports